import { fromJS } from 'immutable';
import {
    GET_APPOINTMENTS,
    GET_APPOINTMENTS_SUCCESSFUL,
    GET_APPOINTMENTS_FAILED,
    POST_APPOINTMENT,
    POST_APPOINTMENT_SUCCESSFUL,
    POST_APPOINTMENT_FAILED,
    PUT_APPOINTMENT,
    PUT_APPOINTMENT_SUCCESSFUL,
    PUT_APPOINTMENT_FAILED,
    RESET_APPOINTMENTS_FLAG,
    VIEW_APPOINTMENT,
    NEW_APPOINTMENT
} from '../actions/appointments';

const initialState = fromJS({
    isFetching: false,
    isFailed: false,
    isSaving: false,
    isSaved: false,
    isViewing: false,
    selectedDate: null,
    data: {},
    activeAppointment: null
});

export default function appointments(state = initialState, action) {

    let dateKey = null;
    let appointment = null;
    let oldDate = null;

    switch (action.type) {
        case RESET_APPOINTMENTS_FLAG:
            return state.merge(
                {
                    isSaving: false,
                    isSaved: false,
                    isFailed: false
                }
            );

        case GET_APPOINTMENTS:
            return state.merge(
                {
                    isFetching: true,
                    isSaving: false
                }
            );

        case GET_APPOINTMENTS_SUCCESSFUL:
            return state.merge(
                {
                    isFetching: false,
                    data: action.appointments
                }
            );

        case GET_APPOINTMENTS_FAILED:
            return state.merge(
                {
                    isFetching: false,
                    isFailed: true
                }
            );

        case POST_APPOINTMENT:
            return state.merge(
                {
                    isSaving: true,
                    isSaved: false
                }
            );

        case POST_APPOINTMENT_SUCCESSFUL:
            dateKey = Object.keys(action.appointment);
            appointment = action.appointment[dateKey[0]][0];

            state = state.updateIn(['data', dateKey[0]], arr => {
                if (typeof arr === 'undefined') {
                    arr = fromJS([appointment]);

                    return arr;
                }

                return arr.push(appointment);
            });

            console.log(state.toJS());

            state = state.set('isSaving', false);
            state = state.set('isSaved', true);

            return state;

        case POST_APPOINTMENT_FAILED:
            return state.merge(
                {
                    isSaving: false,
                    isFailed: true
                }
            );

        case PUT_APPOINTMENT:
            return state.merge(
                {
                    isSaving: true,
                    isFailed: false
                }
            );

        case PUT_APPOINTMENT_SUCCESSFUL:
            console.log(action.appointment);
            dateKey = Object.keys(action.appointment);
            appointment = action.appointment[dateKey[0]][0];
            oldDate = action.appointment.old_date;

            console.log('old_date', oldDate);

            if (typeof oldDate === 'undefined') {
                state = state.updateIn(['data', dateKey[0]], arr => {
                    const index = arr.findIndex((item) => item.get('appointment_id') === appointment.appointment_id);

                    return arr.update(index, (item) => fromJS(appointment));
                });
            }

            if (typeof oldDate !== 'undefined') {
                // If same date was updated
                if (dateKey[0] === oldDate) {
                    state = state.updateIn(['data', dateKey[0]], arr => {
                        const index = arr.findIndex((item) => item.get('appointment_id') === appointment.appointment_id);

                        return arr.update(index, (item) => fromJS(appointment));
                    });
                }

                // If the date was updated
                if (dateKey[0] !== oldDate) {
                    // remove the old one
                    state = state.updateIn(['data', oldDate], arr => {
                        const index = arr.findIndex((item) => item.get('appointment_id') === appointment.appointment_id);

                        return arr.delete(index);
                    });

                    // insert the new one
                    state = state.updateIn(['data', dateKey[0]], arr => {
                        if (typeof arr === 'undefined') {
                            arr = fromJS([appointment]);

                            return arr;
                        }

                        return arr.push(appointment);
                    });
                }
            }

            state = state.set('isSaving', false);
            state = state.set('isSaved', true);

            return state;

        case PUT_APPOINTMENT_FAILED:
            return state.merge(
                {
                    isSaving: false,
                    isFailed: true
                }
            );

        case NEW_APPOINTMENT:
            return state.merge(
                {
                    isViewing: false,
                    activeAppointment: null
                }
            );

        case VIEW_APPOINTMENT:
            return state.merge(
                {
                    isViewing: true,
                    activeAppointment: action.appointment
                }
            );

        case 'ON_NEW_APPOINTMENT':
            // objKey = Object.keys(action.data);
            //
            // if (typeof state.data[objKey[0]] === 'undefined') {
            //     state.data[objKey[0]] = (action.data[objKey[0]]);
            //     break;
            // }

            // let appendData = action.data[objKey[0]];
            // state.data[objKey[0]].push(appendData[0]);
            break;
        case 'ON_UPDATED_APPOINTMENT':
            // objKey = Object.keys(action.data);
            //
            // updatedAppointment = action.data[objKey[0]][0];
            //
            // if (typeof state.data[objKey[0]] === 'undefined') {
            //     state.data[objKey[0]] = (action.data[objKey[0]]);
            //
            //     if (state.data[action.data.old_date].length <= 1) {
            //
            //         delete state.data[action.data.old_date];
            //     } else {
            //         index = state.data[action.data.old_date].findIndex((item, i) => {
            //             return item.appointment_id === updatedAppointment.appointment_id
            //         });
            //
            //         state.data[action.data.old_date].splice(index, 1);
            //     }
            //
            //     break;
            // }
            //
            // index = state.data[objKey[0]].findIndex((item, i) => {
            //     return item.appointment_id === updatedAppointment.appointment_id
            // });
            //
            // state.data[objKey[0]][index] = updatedAppointment;
            
            break;
        case 'ON_OPEN_APPOINTMENT_MODAL':
            // state = Object.assign({}, state, {
            //     form: action.data
            // });
            
            break;
        case 'ON_SELECTED_A_DATE':
            // state = Object.assign({}, state, {
            //     appointmentDate: action.data
            // });

            break;
        case 'ON_UPDATED_APPOINTMENT_STATUS':
            // objKey = Object.keys(action.data);
            //
            // updatedAppointment = action.data[objKey[0]][0];
            // index = state.data[objKey[0]].findIndex((item, i) => {
            //     return item.appointment_id === updatedAppointment.appointment_id
            // });
            //
            // state.data[objKey[0]][index] = updatedAppointment;

            break;
        default:
            return state;
    }

    return state;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/appointments.js
 **/